import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, Button, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";
import AppBackground from "../components/layout/AppBackground";

const VerifyEmail = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [userName, setUserName] = useState("");
  const { t, i18n } = useTranslation("verify");
  const [flow, setFlow] = useState("signup");
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setStatus(queryParams.get("status"));
    setUserName(queryParams.get("name") || "");
    setFlow(queryParams.get("flow") || "signup");
  }, [location.search]);

  const getMessage = () => {
    switch (status) {
      case "success":
        return flow === "early_pitchers"
          ? t("success_early_pitchers")
          : t("success");
      case "expired":
        return t("expired");
      case "invalid":
        return t("invalid");
      case "already_verified":
        return t("already_verified");
      case "not_found":
        return t("not_found");
      default:
        return t("checking");
    }
  };

 const getMessage_description = () => {
    switch (status) {
      case "success":
        return flow === "early_pitchers"
          ? t("success_early_pitchers_description")
          : "";
      case "expired":
        return "";
      case "invalid":
        return "";
      case "already_verified":
        return "";
      case "not_found":
        return "";
      default:
        return t("checking_instructions");
    }
  };

  const isSuccess = status === "success" || status === "already_verified";

  return (
    <AppBackground
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: 500,
          backgroundColor: "#212121",
          color: "#fff",
          borderRadius: 4,
          p: 4,
          textAlign: "center",
          boxShadow: "0 0 20px rgba(0,0,0,0.5)",
        }}
      >
        <Box mb={3}>
          <img
            src="/assets/logo-icon.png"
            alt="Pitchest Logo"
            style={{ height: 60, marginBottom: 8 }}
          />
          {/* <Typography variant="h6" sx={{ color: "#bbb" }}>Pitchest</Typography> */}
        </Box>

        {isSuccess ? (
          <CheckCircleOutlineIcon sx={{ fontSize: 64, color: theme.palette.success.light, mb: 2 }} />
        ) : status === "check_email" ? (
          <WarningAmberIcon sx={{ fontSize: 64, color: "#FBBF24", mb: 2 }} />
        ) : (
          <ErrorOutlineIcon sx={{ fontSize: 64, color: theme.palette.error.light, mb: 2 }} />
        )}

        {userName && isSuccess && (
          <Typography variant="h4" fontWeight={500} sx={{ mb: 4 }}>
            {t("hello", { name: userName })}
          </Typography>
        )}

        <Typography variant="h5" fontWeight={600} gutterBottom >
          {getMessage()}
        </Typography>

        {getMessage_description() !== "" && (
          <Typography variant="body1" fontWeight={600} sx={{ mb: 2, mt: 3 }} gutterBottom>
            {getMessage_description()}
          </Typography>
        )}

        <Button
          variant="contained"
          onClick={() => navigate("/login")}
          sx={{ mt: 3, borderRadius: 999, px: 4, py: 1.2 }}
        >
          {isSuccess ? t("start_pitchest") : t("go_to_pitchest")}
        </Button>
      </Box>
    </AppBackground>
  );
};

export default VerifyEmail;
